import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

function PhysicianProtectedRoutes({ component: Component, ...restOfProps }) {
  const myrole = useSelector((state) => state?.Auth?.role);

  const isLogin = useSelector((state) => state.Auth.isLogin);
  return <>{isLogin && myrole == "physician" ? <Outlet /> : <Navigate to="/" />}</>;
}

export default PhysicianProtectedRoutes;